import Home from "./pages/home";
import NewServices from "./pages/newServices";
import Shop from "./pages/newShop";
import Education from "./pages/education";
import ContactUs from "./pages/contactus";
import ProductDetail from "./pages/productShopDetail";
import Formation from "./educationv2/detailedFormation"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BasketProvider } from "./context/basketContext";
import axios from "axios";
import { useEffect } from "react";
import { CardItemsProvider } from "./context/cardContext";
import Panier from "./pages/panier";
import EndOrder from "./newShop/EndOrder";


export default function App() {
  useEffect(() => {  
    axios({
      method: "get",
      url: process.env.REACT_APP_BACKEND_URL + "shop/Products",
      headers: { "Content-Type": "multipart/form-data" },
    }).then((resp) => {
      console.log(" Welcome to maker Skills up")
    });
  }, []);
  return (
    <BrowserRouter basename="/">
 
    <BasketProvider>
          <CardItemsProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<NewServices />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/learn" element={<Education />} />
              <Route path={`/education/formation/:id`} element={<Formation/>} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/panier" element={<Panier />} />
              <Route path="/validate" element={<EndOrder />} />
              <Route
                path={`/shop/detail/produit/:id`}
                element={<ProductDetail />}
              />
            </Routes>
          </CardItemsProvider>
        </BasketProvider>

    </BrowserRouter>
  );
}
